<template>
  <v-app>
    <v-container fluid>
      <template v-if="$insertAccess($route.path)">
        <v-form ref="form" @submit.prevent="submit">
          <v-row>
            <v-col cols="12">
              
              <v-card>
                <v-card-title class="text-subtitle-1 bg-blue-grey-lighten-4 mb-0">
                  <span>{{
                    isEntryMode ? "Add New Internal Bill" : "Update Internal Bill"
                  }}</span>
                </v-card-title>

                <v-card-text>
                  <v-row class="pt-2">
                    <v-col lg="3" cols="12">
                      <v-date-input 
                        input-format="dd/mm/yyyy" 
                        v-model="date.value.value" 
                        label="Claim Date" 
                        variant="outlined" 
                        density="compact" 
                        bg-color="grey-lighten-4" 
                        prepend-icon="" 
                        hide-details="auto"
                        prepend-inner-icon="mdi-calendar"
                        autocomplete="off" 
                        clearable
                        :error-messages="date.errorMessage.value"
                      >
                          <template #label>
                            Claim Date <span class="text-red-accent-4">*</span>
                          </template>
                      </v-date-input>
                    </v-col>
                  </v-row>

                </v-card-text>
              </v-card>
              
            </v-col>

            <v-col>
              <v-card>
                <v-card-title class="text-subtitle-1 bg-blue-grey-lighten-4 mb-0">
                  Claim Details
                </v-card-title>

                <v-card-text>
                  <template v-for="(detail, index) in claimDetails" :key="index">
                    <v-row style="border-bottom: 1px solid #ccc; padding-top: 10px;" align="center" no-gutters dense>
                      <v-col cols="12" md="3" class="pr-2 pa-0">
                        <v-text-field 
                          v-model.number="detail.amount" 
                          label="Amount" 
                          variant="outlined"
                          density="compact" 
                          bg-color="grey-lighten-4" 
                          class="ma-0" 
                          type="number" 
                          clearable
                          hide-spin-buttons
                        >
                          <template #label>
                            Amount <span class="text-red-accent-4">*</span>
                          </template>
                        </v-text-field>

                        <v-text-field 
                          v-model="detail.from_address" 
                          label="From" 
                          variant="outlined"
                          density="compact" 
                          bg-color="grey-lighten-4" 
                          class="ma-0" 
                          rows="2" 
                          clearable
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="3" class="pr-2 pa-0">
                        <v-autocomplete 
                          v-model="detail.type" 
                          label="Claim Type" 
                          variant="outlined" 
                          density="compact"
                          bg-color="grey-lighten-4" 
                          class="ma-0" 
                          :items="getHrmClaimTypeList" 
                          item-title="name"
                          item-value="id" 
                          autocomplete="off" 
                          clearable
                        
                            :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                          <template #label>
                            Claim Type <span class="text-red-accent-4">*</span>
                          </template>
                        </v-autocomplete>

                        <v-text-field 
                          v-model="detail.to_address" 
                          label="To" 
                          variant="outlined"
                          density="compact" 
                          bg-color="grey-lighten-4" 
                          class="ma-0" 
                          rows="2" 
                          clearable
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" lg="2" md="2" class="pr-2 pa-0">
                        <v-date-input 
                          input-format="dd/mm/yyyy" 
                          v-model="detail.claim_date" 
                          label="Claim Date" 
                          variant="outlined"
                          density="compact" 
                          bg-color="grey-lighten-4" 
                          class="ma-0" 
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar-start" 
                          autocomplete="off" 
                          clearable
                        >
                          <template #label>
                            Date <span class="text-red-accent-4">*</span>
                          </template>
                        </v-date-input>
                        
                        <v-text-field 
                          v-model="detail.travelled_by" 
                          label="Travelled By" 
                          variant="outlined"
                          density="compact" 
                          bg-color="grey-lighten-4" 
                          clearable
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" lg="3" md="2" class="pr-2 pa-0">
                        <v-textarea 
                          v-model="detail.description" 
                          label="Purpose" 
                          variant="outlined"
                          density="compact" 
                          bg-color="grey-lighten-4"  
                          rows="4" 
                          clearable
                        ></v-textarea>
                      </v-col>

                      <v-col cols="12" md="1" class="pl-4">
                        <v-btn 
                          v-if="claimDetails.length>1"
                          variant="tonal" 
                          color="primary"
                          class="mb-2"
                          @click="removeClaimDetailRow(index)" 
                        >
                          <v-icon color="red" icon="mdi-delete" size="large"></v-icon>
                        </v-btn>

                        <v-btn 
                          v-if="index === claimDetails.length-1"
                          @click="addClaimDetailRow"
                          variant="tonal" 
                          color="primary" 
                        >
                          <v-icon color="info" icon="mdi-plus" size="large"></v-icon>
                        </v-btn>
                      </v-col>

                    </v-row>
                  </template>

                  <v-card-actions>
                    <v-row class="pt-2">
                      <v-col class="pa-0">
                        <v-textarea 
                          v-model="remarks.value.value" 
                          label="Remarks" 
                          variant="outlined" 
                          density="compact"
                          bg-color="grey-lighten-4" 
                          rows="2" 
                          clearable
                          :error-messages="remarks.errorMessage.value"
                        ></v-textarea>
                      </v-col>
                      
                      <v-col cols="6">
                        <v-layout class="justify-end">
                          <v-btn 
                            class="bg-grey-darken-1 me-2" 
                            variant="flat"
                            type="button"
                            @click="submitClaim(0)"
                          >
                            DRAFT
                          </v-btn>

                          <v-btn 
                            class="bg-primary" 
                            variant="flat" 
                            type="button" 
                            @click="submitClaim(1)"
                          >
                            {{ buttonText }}
                          </v-btn>
                        </v-layout>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card-text>
              </v-card>
              
            </v-col>
          </v-row>
        </v-form>
      </template>
    </v-container>
  </v-app>
</template>


<script>
import { ref } from "vue";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  components: {},
  data: () => ({
    itemsPerPage: 10,
    claimPanel: [0],
    search: "",
    claimTypeLoading: false,
    buttonText: 'POST',
    oldMeetingIds: []
  }),

  created() {
    const p = this.$store.dispatch("hrmClaimTypeSetup/getClaimTypeList");
    // this.$store.dispatch('getHrmEmployeeMeetingList', { is_visit_bill: true, old_meeing_ids: this.oldMeetingIds })
  },

  computed: {
    getHrmEmployeeMeetingList() {
      const data = this.$store.getters.getHrmEmployeeMeetingList;
      return data;
    },
    getHrmClaimTypeList() {
      const list = this.$store.getters["hrmClaimTypeSetup/getHrmClaimTypeList"];
      return Array.isArray(list) ? list.filter((item) => item.status == 1) : [];
    }

  },

  methods: {
    addClaimDetailRow() {
      this.claimDetails.push({
        type: '',
        amount: '',
        claim_date: '',
        description: '',
        from:'',
        to:'',
        travelled_by:'',
      });
    },
    removeClaimDetailRow (index) {
      if (this.claimDetails.length > 1) {
        this.claimDetails.splice(index, 1);
      }
    },
    
  },

  setup() {
    const { handleSubmit, resetForm, errors } = useForm({
      validationSchema: yup.object({
        bill_type: yup.string().required("Bill type is required"),
        date: yup.string().required("Claim date is required"),
        remarks: yup.string().nullable(),
      }),
    });

    const claim_master_id = useField("claim_master_id");
    const date = useField("date");
    const bill_type = useField("bill_type");
    const remarks = useField("remarks");
    const details = useField("details");
    const status = useField("status");

    const claimDetails = ref([
      {
        type: null,
        amount: null,
        claim_date: null,
        description: null,
        from_address: null,
        to_address: null,
        travelled_by: null,
      },
    ]);

    const router = useRouter();
    const store = useStore();
    const errorMessages = ref("");
    const isEntryMode = ref(true);
    const currentStatus = ref(0);
    const editingClaimId = ref(null);

    const submitClaim = (statusValue) => {
      status.value.value = statusValue;
      
      submit();
    };

    const validateClaimDetails = (details) => {
      const invalidRows = [];

      details.forEach((detail, index) => {
        const missingFields = [];

        if ([null, undefined, ""].includes(detail.type)) {
          missingFields.push("Type");
        }
        if ([null, undefined, ""].includes(detail.amount)) {
          missingFields.push("Amount");
        }
        if ([null, undefined, ""].includes(detail.claim_date)) {
          missingFields.push("Claim Date");
        }

        if (missingFields.length) {
          invalidRows.push({
            row: index + 1,
            fields: missingFields.join(", "),
          });
        }
      });

      return invalidRows;
    };

    const submit = handleSubmit((values) => {
      const invalidRows = validateClaimDetails(claimDetails.value);

      if (invalidRows.length) {
        const firstInvalid = invalidRows[0];
        toast.error(`Please fill the required fields for row ${firstInvalid.row}: ${firstInvalid.fields}`);
        return;
      }


      values.date = formattedDate(date.value.value)
      values.details = claimDetails.value.map(detail => ({
        ...detail,
        claim_date: detail.claim_date
          ? formattedDate(detail.claim_date)
          : null,
      }));

      values.bill_type = "internal_bill"

      store.dispatch("saveUpdateClaim", values) 
        .then((response) => {  
          resetForm();
          toast.success(response.message, {
              timeout: 3000,
          });
          store.dispatch("getClaimList")
          setTimeout(() => {  
              router.push({ path: "claim-list" });
          }, 2000);
        })
        .catch((error) => { 
          toast.error(error?.response?.data?.message)   
        })
    });

    return {
      submit,
      submitClaim,
      remarks,
      claim_master_id,
      bill_type,
      date,
      claimDetails,
      errorMessages,
      isEntryMode,
      currentStatus,
      editingClaimId,
      errors,
    };
  },

  mounted() {
    const editingClaim = this.$store.getters.getEditingHrmClaim;

    if (editingClaim) {
      this.isEntryMode = false;
      this.editingClaimId = editingClaim.id;
      this.buttonText = "Update";

      this.claim_master_id.value.value = editingClaim?.id;
      this.bill_type.value.value = "internal_bill";
      this.date.value.value = editingClaim.date ?? "";
      this.remarks.value.value = editingClaim.remarks ?? "";
      
      const mappedDetails = editingClaim?.details?.map((claim) => {
        return {
            id: claim?.id,
            type: claim?.type_id,
            amount: claim?.amount,
            claim_date: claim?.claim_date ?? "",
            description: claim?.description ?? "",
            from_address: claim?.from_address ?? "",
            to_address: claim?.to_address ?? "",
            travelled_by: claim?.travelled_by ?? "",
      }})
          
      this.claimDetails = mappedDetails;
    } else {  
      this.bill_type.value.value = "internal_bill";
    }

    this.$store.dispatch('getHrmEmployeeMeetingList', { is_visit_bill: true, old_meeing_ids: this.oldMeetingIds })

  },

  beforeUnmount() {
    this.$store.commit('UNSET_EDITING_HRM_CLAIM');
  },
};
</script>

<style scoped>
.v-card-title {
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
}
</style>

